import api from "src/services/api";

export interface MarcacionBloqueoItem {
  legajo: number;
  motivo?: string;
  actualizado_en?: string;
  actualizado_por?: string;
}

export interface MarcacionBloqueoHistorialItem {
  id: number;
  legajo: number;
  accion: "BLOQUEAR" | "DESBLOQUEAR";
  bloqueado: boolean;
  motivo?: string;
  cambiado_en?: string;
  cambiado_por?: string;
}

export const obtenerMarcacionesBloqueos = async (): Promise<MarcacionBloqueoItem[]> => {
  const { data } = await api.get<{ datos?: MarcacionBloqueoItem[] }>("inicio/marcaciones-bloqueos");
  return data?.datos || [];
};

export const actualizarMarcacionBloqueo = async (
  payload: { legajo: number; bloqueado: boolean; motivo?: string }
): Promise<MarcacionBloqueoItem[]> => {
  const { data } = await api.put<{ datos?: MarcacionBloqueoItem[] }>("inicio/marcaciones-bloqueos", payload);
  return data?.datos || [];
};

export const obtenerMarcacionesBloqueosHistorial = async (
  limite = 100
): Promise<MarcacionBloqueoHistorialItem[]> => {
  const { data } = await api.get<{ datos?: MarcacionBloqueoHistorialItem[] }>(
    `inicio/marcaciones-bloqueos/historial?limite=${limite}`
  );
  return data?.datos || [];
};

export const obtenerEstadoBloqueoMarcacion = async (): Promise<{ legajo: number | null; bloqueado: boolean }> => {
  const { data } = await api.get<{ legajo?: number | null; bloqueado?: boolean }>("inicio/marcaciones-bloqueos/mi-estado");
  return {
    legajo: data?.legajo ?? null,
    bloqueado: Boolean(data?.bloqueado),
  };
};
